type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  action?: string;
  tone?: 'primary' | 'accent' | 'secondary';
  id?: string;
};

const toneMap = {
  primary: 'bg-primary-100 text-primary-700 dark:text-primary-300',
  accent: 'bg-accent-100 text-accent-800 dark:text-accent-300',
  secondary: 'bg-secondary-100 text-secondary-800 dark:text-secondary-300',
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  action,
  tone = 'primary',
  id,
}: SectionHeadingProps) {
  return (
    <div id={id} className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between md:mb-8">
      <div className="max-w-2xl">
        <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold tracking-wide ${toneMap[tone]}`}>
          <i className="ri-bookmark-3-line text-sm" />
          {eyebrow}
        </span>
        <h2 className="mt-3 font-heading text-2xl font-black leading-snug tracking-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc ? <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p> : null}
      </div>
      {action ? (
        <a
          href="#top"
          className="inline-flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          {action}
          <i className="ri-arrow-right-line text-base" />
        </a>
      ) : null}
    </div>
  );
}